module.exports = __webpack_public_path__ + "static/img/graphql.7c64d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphql.png
// module id = ImdJ
// module chunks = 1